import {LucideFlame, LucideDroplets, LucideWind, LucideStar} from "lucide-react";
import {BolFireStrikePage} from "../../pages/HomePage";

const trustPoints = [
    {icon: LucideDroplets, label: "Werkt nat"},
    {icon: LucideWind, label: "Werkt in wind"},
    {icon: LucideFlame, label: "3.000°C vonken"},
];

export const HeroSection = () => {
    return (
        <section className="relative overflow-hidden bg-ink-950">
            {/* Ambient ember glow */}
            <div className="pointer-events-none absolute inset-0 bg-ember-glow" />
            <div className="pointer-events-none absolute -top-32 -right-24 h-96 w-96 rounded-full bg-ember-600/20 blur-3xl animate-flicker" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

                    <div className="text-center lg:text-left">
                        <span className="inline-flex items-center gap-2 rounded-full border border-ember-500/40 bg-ember-500/10 px-4 py-1.5 text-sm font-medium text-ember-300">
                            <LucideFlame className="h-4 w-4" />
                            Militaire kwaliteit · Survival proof
                        </span>

                        <h1 className="mt-6 font-display font-bold uppercase tracking-tight text-5xl lg:text-7xl leading-[0.95] text-ink-50">
                            Start <span className="text-fire">vuur</span><br />waar dan ook
                        </h1>

                        <p className="mt-6 text-lg lg:text-xl text-ink-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
                            Professionele magnesiumstaven die direct ontvlammen — zelfs in natte,
                            winderige en extreme omstandigheden.
                        </p>

                        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <button
                                onClick={() => window.open(BolFireStrikePage, "_blank")}
                                className="inline-flex items-center justify-center gap-2 bg-fire-gradient text-white px-8 py-4 rounded-xl
                                           font-semibold text-lg shadow-ember hover:brightness-110 hover:scale-[1.02] transition-all"
                            >
                                <LucideFlame className="h-5 w-5" />
                                Bestel Nu
                            </button>

                            <a href="#instructies">
                                <button className="w-full sm:w-auto inline-flex items-center justify-center bg-ink-800 text-ink-100 px-8 py-4 rounded-xl
                                                   font-semibold text-lg border border-ink-600 hover:border-ember-500/60 hover:text-white transition-colors">
                                    Bekijk instructies
                                </button>
                            </a>
                        </div>

                        {/* Social proof */}
                        <div className="mt-8 flex items-center gap-3 justify-center lg:justify-start">
                            <div className="flex text-ember-400">
                                {Array.from({length: 5}).map((_, i) => (
                                    <LucideStar key={i} className="h-5 w-5" fill="currentColor" />
                                ))}
                            </div>
                            <span className="text-sm text-ink-300">
                                Vertrouwd door duizenden avonturiers op Bol.com
                            </span>
                        </div>
                    </div>

                    {/* Visual */}
                    <div className="relative">
                        <div className="absolute -inset-4 bg-fire-gradient opacity-30 blur-2xl rounded-[2rem]" />
                        <div className="relative rounded-3xl p-2 bg-ink-800/80 border border-ink-700 shadow-2xl">
                            <img
                                src="/img/fs3-sparking-fire.jpg"
                                alt="Survival-expert slaat vonken uit een ferrostaaf met fel licht"
                                className="w-full h-72 lg:h-[28rem] object-cover rounded-2xl"
                            />
                        </div>
                        <div className="absolute -bottom-4 -left-4 sm:-left-6 bg-ink-900/90 backdrop-blur border border-ink-700 rounded-2xl px-5 py-3 shadow-ember-sm">
                            <p className="font-display text-2xl font-bold text-fire leading-none">3.000°C</p>
                            <p className="text-xs text-ink-300 mt-1">vonk temperatuur</p>
                        </div>
                    </div>
                </div>

                {/* Trust strip */}
                <div className="mt-16 grid grid-cols-3 gap-4 max-w-2xl mx-auto lg:mx-0">
                    {trustPoints.map(({icon: Icon, label}) => (
                        <div key={label} className="flex items-center justify-center lg:justify-start gap-2.5 text-ink-200">
                            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-ink-800 border border-ink-700 text-ember-400">
                                <Icon className="h-5 w-5" />
                            </span>
                            <span className="text-sm font-medium">{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
